import type { Props } from './Svg'
import { Svg } from './Svg'

export function WindIcon(props: Props) {
  return (
    <Svg strokeWidth="2.4" {...props}>
      <path d="M12 12c3.055 0 5.576-2.23 5.576-4.994 0-2.763-2.521-4.994-5.576-4.994V12Zm0 0c0 3.055 2.23 5.576 4.994 5.576s5.043-2.521 5.043-5.576H12Zm0 0c-3.054 0-5.576 2.23-5.576 4.994S8.946 22.037 12 22.037V12Zm0 0c0-3.054-2.23-5.576-4.994-5.576-2.763 0-4.994 2.522-4.994 5.576H12Z" />
    </Svg>
  )
}
